import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import { adaptStoreToSortOptionHrefs } from 'src/adapters/storeToPageURL/adaptStoreToSortOptionHrefs';
import { adaptStoreToUIFacetHrefs } from 'src/adapters/storeToPageURL/adaptStoreToUIFacetHrefs';
import { adaptFacetToUIFacet } from 'src/adapters/storeToUI/adaptFacetToUIFacet';
import { ListingsControls } from 'src/components/organisms/ListingsControls/ListingsControls';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const ListingsControlsContainer = () => {
  const state = useSelector((s: ReduxApplicationState) => s);

  const facets = useMemo(() => {
    const uiFacet = adaptFacetToUIFacet(
      state.productsQuery.facets,
      state.productsQuery.taxonomyAttributeAliases,
    );

    return adaptStoreToUIFacetHrefs(state, uiFacet);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `state` is used in the callback; facet hrefs only change when query, path, or hash change
  }, [state.productsQuery, state.router.location.pathname, state.navigation.hash]);

  const sortOptions = useMemo(
    () => adaptStoreToSortOptionHrefs(state),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sort hrefs only change when query, path, or hash change
    [state.productsQuery, state.router.location.pathname, state.navigation.hash],
  );

  const onAllFacetsVisible = () => {
    // Defer off the critical path: impressions are fire-and-forget and do not gate navigation.
    deferTracking(() =>
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Filters',
        event_action: 'filter impression',
        event_label: 'all filters viewed',
      }),
    );
  };

  return (
    <ListingsControls
      facets={facets}
      onAllFacetsVisible={onAllFacetsVisible}
      sortOptions={sortOptions}
    />
  );
};
